import React from "react";

export function Stat({ icon: Icon, label, value, sub, testId, accent = "bg-white" }) {
  return (
    <div className={`rounded-3xl ${accent} shadow-card p-6`} data-testid={testId}>
      <div className="flex items-center gap-2 text-ink-500 text-[11px] font-semibold uppercase tracking-[0.15em]">
        {Icon && <Icon className="h-3.5 w-3.5" strokeWidth={1.75} />} {label}
      </div>
      <div className="font-heading text-3xl text-ink-900 mt-2 tracking-tight">{value ?? "—"}</div>
      {sub && <div className="text-xs text-ink-500 mt-1">{sub}</div>}
    </div>
  );
}

const TONES = {
  active: "bg-sage-100 text-sage-700", trialing: "bg-sage-100 text-sage-700", grace: "bg-amber-100 text-amber-800",
  past_due: "bg-amber-100 text-amber-800", pending: "bg-cream-100 text-ink-700", incomplete: "bg-cream-100 text-ink-700",
  inactive: "bg-ink-100 text-ink-700", none: "bg-ink-100 text-ink-700", unpaid: "bg-rust-500/10 text-rust-600",
  canceled: "bg-rust-500/10 text-rust-600", cancelled: "bg-rust-500/10 text-rust-600", revoked: "bg-rust-500/10 text-rust-600",
  declined: "bg-ink-100 text-ink-700", closed: "bg-ink-100 text-ink-700", accepted: "bg-sage-100 text-sage-700",
  expired: "bg-ink-100 text-ink-700", failed: "bg-rust-500/10 text-rust-600", paid: "bg-sage-100 text-sage-700",
};

export function StatusPill({ status, label, testId }) {
  const key = String(status || "none").toLowerCase();
  return (
    <span data-testid={testId} className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ${TONES[key] || "bg-cream-100 text-ink-700"}`}>
      {label || key}
    </span>
  );
}

export function Card({ title, children, actions, testId, className = "" }) {
  return (
    <section className={`rounded-3xl bg-white shadow-card p-6 ${className}`} data-testid={testId}>
      {(title || actions) && (
        <div className="flex items-center justify-between gap-3 mb-4">
          {title && <h2 className="font-heading text-lg text-ink-900">{title}</h2>}
          {actions}
        </div>
      )}
      {children}
    </section>
  );
}

export const fmtDate = (v) => (v ? new Date(v).toLocaleDateString() : "—");
export const fmtDateTime = (v) => (v ? new Date(v).toLocaleString() : "—");
export const asList = (d, ...keys) => {
  if (Array.isArray(d)) return d;
  for (const k of keys) if (Array.isArray(d?.[k])) return d[k];
  return [];
};
